<template></template>

<script>
export default {
  title: "New",
  access_code: "UBF_FORM01",
  created() {
    this.$router.push("/Builder/FormBuilder/RequestForm").catch(err => {});
  }
};
</script>

<style>
</style>